import $ from 'jquery';
import Api from '../util/Api';
import CatalogItem from '../template/CatalogItem';

const CatalogService = {
    getItems(parameters) {
        return Api.get('/api/catalog/', parameters);
    },
    renderItems(items, append = false) {
        const countDom = $('.catalog-section-quantity span');
        const html = items.map(item => CatalogItem(item));
        if (append) {
            let itemsCount = countDom.text();
            itemsCount = parseInt(itemsCount, 10) + items.length;
            countDom.text(itemsCount);

            $('.catalog-section-items').append(html);
        } else {
            $('.catalog-section-items').html(html);
            countDom.text(items.length);
        }
    }
};

export default CatalogService;
